import type { SidecarOperatingSystem } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const sidecarUpdateAtom = createMutationAtomFactory(
  'settings.sidecarUpdate',
  (params: {
    id: string;
    name?: string | null;
    operatingSystem?: SidecarOperatingSystem | null;
    operatingSystemVersion?: string | null;
    facilityId?: string | null;
    discoveryEnabled?: boolean | null;
  }) => ({
    iotSidecarUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
          operatingSystem: params.operatingSystem,
          operatingSystemVersion: params.operatingSystemVersion,
          facilityId: params.facilityId,
          settings: { discoveryEnabled: params.discoveryEnabled },
        },
      },
      id: true,
      name: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
